import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { IScoring } from "./asset"
import { DateTimeDefaultValue } from "./datetime"

export class InspectionStartDateOptionsVM extends CommonOptionVM {
  future_date?: boolean
  prior_date?: boolean
  date?: boolean
  time?: boolean
  required?: boolean
  require_media?: boolean
  require_note?: boolean
  enable_score?: boolean
  scoring?: IScoring
  /**
   * *** ### (remove null) and add real types
   * */
  date_time_shape?: "year_month_day_hour_minute"
  default_value?: DateTimeDefaultValue

  constructor(data: Partial<InspectionStartDateOptionsVM> = {}) {
    super(data)
    this.future_date = data?.future_date || undefined
    this.prior_date = data?.prior_date || undefined
    this.required = data?.required || undefined
    this.require_media = data?.require_media || undefined
    this.require_note = data?.require_note || undefined
    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined

    /**
     * *** ### heck date_time_shape then insert these
     * */
    this.date = data?.date ?? undefined
    this.time = data?.time ?? undefined
    this.date_time_shape = "year_month_day_hour_minute" // Inspection end date should always have this shape
    this.default_value = data?.default_value ? {
      /**
       * *** ### these types is not optional
       * */
      type: data?.default_value?.type || undefined,
      period: data?.default_value?.period || undefined,
      period_type: data?.default_value?.period_type
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    if (this.prior_date && this.default_value?.type === 'future') {
      errors.push({
        key: 'default_value.type',
        error_message: 'type "future" is not allowed when prior_date is true'
      })
    }
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default InspectionStartDateOptionsVM
